export default __webpack_public_path__ + "static/media/ee359fa92500d26e.f2607aea7e2feba727c9b456eb7b1110.svg";